import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

export type StatusTone = 'green' | 'blue' | 'amber' | 'red' | 'grey';

const TONES: Record<StatusTone, { pill: string; dot: string }> = {
	green: { pill: 'bg-green-100 text-green-500', dot: 'bg-green-500' },
	blue: { pill: 'bg-blue-100 text-blue-500', dot: 'bg-blue-500' },
	amber: { pill: 'bg-amber-50 text-amber-500', dot: 'bg-amber-500' },
	red: { pill: 'bg-red-50 text-red-500', dot: 'bg-red-500' },
	grey: { pill: 'bg-gray-100 text-gray-800', dot: 'bg-gray-800' }
};

/** Dot + label pill used in the settings tables (Figma "Tags", Dot type). */
export function StatusTag({ tone, children, className }: { tone: StatusTone; children: ReactNode; className?: string }) {
	const { pill, dot } = TONES[tone];
	return (
		<span className={cn('inline-flex shrink-0 items-center gap-1.5 rounded-full py-1 pl-1.5 pr-2.5 text-[12px] leading-4 whitespace-nowrap', pill, className)}>
			<span className={cn('size-2 rounded-full', dot)} />
			{children}
		</span>
	);
}
